function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Project_Hourlog",
  "data-name": "Project Hourlog",
  transform: "translate(-93.867)"
}, React.createElement("g", {
  id: "Group_963",
  "data-name": "Group 963",
  transform: "translate(93.867)"
}, React.createElement("g", {
  id: "Group_962",
  "data-name": "Group 962"
}, React.createElement("path", {
  id: "Path_524",
  "data-name": "Path 524",
  d: "M111,0H95.336a1.469,1.469,0,1,0,0,2.938H111A1.469,1.469,0,1,0,111,0Zm0,1.958H95.336a.49.49,0,1,1,0-.979H111a.49.49,0,1,1,0,.979Z",
  transform: "translate(-93.867)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_965",
  "data-name": "Group 965",
  transform: "translate(93.867 26.438)"
}, React.createElement("g", {
  id: "Group_964",
  "data-name": "Group 964"
}, React.createElement("path", {
  id: "Path_525",
  "data-name": "Path 525",
  d: "M111,460.8H95.336a1.469,1.469,0,1,0,0,2.938H111a1.469,1.469,0,1,0,0-2.938Zm0,1.958H95.336a.49.49,0,1,1,0-.979H111a.49.49,0,1,1,0,.979Z",
  transform: "translate(-93.867 -460.8)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_967",
  "data-name": "Group 967",
  transform: "translate(95.825 1.958)"
}, React.createElement("g", {
  id: "Group_966",
  "data-name": "Group 966"
}, React.createElement("path", {
  id: "Path_526",
  "data-name": "Path 526",
  d: "M138.833,45.046a13.076,13.076,0,0,0,3.855-9.307V34.624a.489.489,0,0,0-.49-.49H128.49a.489.489,0,0,0-.49.49v1.116a13.076,13.076,0,0,0,3.855,9.307l.492.492a1.874,1.874,0,0,1,0,2.651l-.492.492A13.075,13.075,0,0,0,128,57.987V59.1a.489.489,0,0,0,.49.49H142.2a.489.489,0,0,0,.49-.49V57.987a13.075,13.075,0,0,0-3.855-9.307l-.492-.492a1.875,1.875,0,0,1,0-2.651Zm-1.184-.2a2.853,2.853,0,0,0,0,4.035l.492.492a12.1,12.1,0,0,1,3.568,8.614v.626H128.979v-.626a12.1,12.1,0,0,1,3.568-8.614l.492-.492a2.853,2.853,0,0,0,0-4.035l-.492-.492a12.1,12.1,0,0,1-3.568-8.614v-.626h12.729v.626a12.1,12.1,0,0,1-3.568,8.614Z",
  transform: "translate(-128 -34.134)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_969",
  "data-name": "Group 969",
  transform: "translate(99.253 6.561)"
}, React.createElement("g", {
  id: "Group_968",
  "data-name": "Group 968"
}, React.createElement("path", {
  id: "Path_527",
  "data-name": "Path 527",
  d: "M195.795,116.049a.7.7,0,0,0-.71-.415c-2.544,0-3.677-.545-4.127-.87a2.093,2.093,0,0,0-1.926-.283,1.93,1.93,0,0,0-1.238,1.329,1.6,1.6,0,0,0-.052.269.517.517,0,0,0,.061.285,10.884,10.884,0,0,0,1.75,2.433l.492.492a3.8,3.8,0,0,1,1.123,2.71.49.49,0,1,0,.979,0,3.807,3.807,0,0,1,1.122-2.71l.493-.493c.121-.12.279-.269.452-.432C195.479,117.175,196.011,116.6,195.795,116.049Zm-2.253,1.6c-.181.171-.347.327-.473.453l-.493.493a4.81,4.81,0,0,0-.919,1.282,4.807,4.807,0,0,0-.919-1.282l-.492-.492a9.391,9.391,0,0,1-1.5-2.063.957.957,0,0,1,.612-.638,1.114,1.114,0,0,1,1.025.154,7.485,7.485,0,0,0,4.21,1.049C194.29,116.948,193.816,117.395,193.542,117.652Z",
  transform: "translate(-187.741 -114.362)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_971",
  "data-name": "Group 971",
  transform: "translate(97.816 20.563)"
}, React.createElement("g", {
  id: "Group_970",
  "data-name": "Group 970"
}, React.createElement("path", {
  id: "Path_528",
  "data-name": "Path 528",
  d: "M173.4,362.768a4.243,4.243,0,0,0-1.5-3.01c-.1-.1-.2-.211-.309-.324a3.276,3.276,0,0,0-2.384-1.034h-2.326a3.277,3.277,0,0,0-2.384,1.034c-.106.114-.21.22-.309.324a4.24,4.24,0,0,0-1.5,3.011.489.489,0,0,0,.488.527h9.727a.49.49,0,0,0,.488-.528Zm-9.658-.451a3.4,3.4,0,0,1,1.155-1.879c.1-.107.21-.218.319-.335a2.292,2.292,0,0,1,1.669-.724h2.326a2.3,2.3,0,0,1,1.669.723c.11.118.217.229.32.336a3.408,3.408,0,0,1,1.154,1.879Z",
  transform: "translate(-162.696 -358.4)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_973",
  "data-name": "Group 973",
  transform: "translate(102.665 15.667)"
}, React.createElement("g", {
  id: "Group_972",
  "data-name": "Group 972"
}, React.createElement("path", {
  id: "Path_529",
  "data-name": "Path 529",
  d: "M247.7,273.067a.489.489,0,0,0-.49.49v.49a.49.49,0,0,0,.979,0v-.49A.489.489,0,0,0,247.7,273.067Z",
  transform: "translate(-247.211 -273.067)",
  fill: "#fff"
}))), React.createElement("g", {
  id: "Group_975",
  "data-name": "Group 975",
  transform: "translate(102.665 18.115)"
}, React.createElement("g", {
  id: "Group_974",
  "data-name": "Group 974"
}, React.createElement("path", {
  id: "Path_530",
  "data-name": "Path 530",
  d: "M247.7,315.733a.489.489,0,0,0-.49.49v.49a.49.49,0,0,0,.979,0v-.49A.489.489,0,0,0,247.7,315.733Z",
  transform: "translate(-247.211 -315.733)",
  fill: "#fff"
}))));

var SvgProjectHourlog = function SvgProjectHourlog(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18.604,
    height: 29.375,
    viewBox: "0 0 18.604 29.375",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProjectHourlog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Project Hourlog.301409e5.svg";
export { ForwardRef as ReactComponent };